import React from "react";
import { useApp } from "../context/AppContext";
import { Heart, Sparkles, Gift } from "lucide-react";

const About = () => {
  const { lang, settings } = useApp();
  return (
    <div className="max-w-4xl mx-auto px-5 sm:px-8 py-16">
      <div className="text-center mb-12">
        <div className="text-[11px] tracking-[0.3em] uppercase text-holy-gold-dark font-semibold mb-3">
          ✦ {lang === "id" ? "Cerita Kami" : "Our Story"} ✦
        </div>
        <h1 className="font-serif text-4xl sm:text-6xl text-holy-red mb-4">Holy Flowy</h1>
        <p className="font-script text-3xl text-foreground">handmade with love</p>
      </div>

      <div className="bg-white rounded-2xl border border-border/60 p-8 md:p-12 prose max-w-none">
        <div className="text-lg leading-relaxed text-foreground space-y-5" data-testid="about-text">
          {((lang === "id" ? settings?.about_id : settings?.about_en) || "")
            .split(/\n+/)
            .map((para) => para.trim())
            .filter(Boolean)
            .map((para, i) => (
              <p key={i}>{para}</p>
            ))}
        </div>
        <div className="grid sm:grid-cols-3 gap-6 mt-10 not-prose">
          {[
            { icon: Heart, t: lang === "id" ? "100% Handmade" : "100% Handmade", d: lang === "id" ? "Setiap tangkai dirakit dengan tangan." : "Each stem assembled by hand." },
            { icon: Sparkles, t: lang === "id" ? "Material Premium" : "Premium Materials", d: lang === "id" ? "Material berkualitas tahan lama." : "Long-lasting quality materials." },
            { icon: Gift, t: lang === "id" ? "Hadiah Sempurna" : "Perfect Gift", d: lang === "id" ? "Kemasan rapi siap diberikan." : "Beautifully packaged & gift-ready." },
          ].map((b, i) => (
            <div key={i} className="text-center bg-cream rounded-2xl p-5">
              <b.icon className="w-7 h-7 text-holy-red mx-auto mb-3" />
              <div className="font-serif text-lg mb-1">{b.t}</div>
              <div className="text-xs text-muted-foreground">{b.d}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default About;
